import { useLanguage } from "@/contexts/LanguageContext";

interface LocalizedPair {
    ar: string;
    en?: string | null;
}

/**
 * Pick the string matching the active language. Falls back to Arabic if the
 * requested language is missing — keeps partially-translated data safe.
 */
export const useLocalized = ({ ar, en }: LocalizedPair): string => {
    const { lang } = useLanguage();
    if (lang === "en") return en && en.length > 0 ? en : ar;
    return ar;
};

export const pickLocalized = (
    lang: "ar" | "en",
    { ar, en }: LocalizedPair,
): string => {
    if (lang === "en") return en && en.length > 0 ? en : ar;
    return ar;
};
